import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_EDIT_REQUEST,
  PROJECT_INFORMATION_EDIT_SUCCESS,
  PROJECT_INFORMATION_EDIT_FAILURE,
  PROJECT_INFORMATION_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_EDIT_SUCCESS:
      return state
        .set('updatedProject', fromJS(action.payload.updatedProject))
        .set('commit', fromJS(action.payload.commit))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case PROJECT_INFORMATION_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('updatedProject', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_INFORMATION_EDIT_RESET:
      return state
        .delete('updatedProject')
        .delete('commit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-edit-reducer.js